import React from 'react';
import { r } from './helpers';
import TrackingPage from '../../pages/customer/TrackingPage';
import OfflinePage from '../../pages/shared/OfflinePage';
import NotFoundPage from '../../pages/shared/NotFoundPage';
import { PublicShopInvoicePage } from '../lazyPages';

/** Public utility routes included in most portal trees. */
export function UtilityRoutes() {
  return (
    <>
      {r('/track/:tracking_id', <TrackingPage />)}
      {r('/invoice/:token', <PublicShopInvoicePage />)}
      {r('/offline', <OfflinePage />)}
    </>
  );
}

export function NotFoundRoute() {
  return r('*', <NotFoundPage />);
}